import { render, staticRenderFns } from "./powerInterests1.vue?vue&type=template&id=50ee4221&scoped=true"
import script from "./powerInterests1.vue?vue&type=script&lang=js"
export * from "./powerInterests1.vue?vue&type=script&lang=js"
import style0 from "./powerInterests1.vue?vue&type=style&index=0&id=50ee4221&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee4221",
  null
  
)

export default component.exports